/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react'

// import Icon, * as IconAnt from '@ant-design/icons'
import { Layout } from 'antd'
import classnames from 'classnames'
import {
  // map,
  get,
} from 'lodash'
// import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useHistory, useParams } from 'react-router-dom'

// import { IconTH, IconEN } from '../components/icons/Languages'
// import { IconTH, IconEN, IconCN } from '../components/icons/Languages'
import { getContent } from '../utils'

import MenuSidebar from './MenuSidebar'

const { Header } = Layout

const Navigator = () => {
  const [isOpen, setIsOpen] = useState(false)
  // const pathname = useLocation().pathname
  // const { i18n } = useTranslation()

  const [commonContent, categoryContent] = useSelector((state) => [
    get(state, 'common.data', {}),
    get(state, 'category.data', []),
  ])
  // const navContent = useSelector((state) => get(state, 'common.data.Navigator', []))

  const slug = useParams()
  const content = getContent(slug, categoryContent)

  const dataMenu = categoryContent.map((v, k) => ({
    title: get(commonContent, `${k === 0 ? 'quickstartGuides' : 'popularTopics'}`, ''),
    list: v,
  }))
  const slugArray = get(content, 'slugArray', [])

  const handleHamburger = () => {
    setIsOpen(!isOpen)
  }

  // const handleChangLang = (lang) => {
  //   i18n.changeLanguage(lang)

  //   if (isOpen) {
  //     setIsOpen(false)
  //   }
  // }

  const history = useHistory()

  const onSelectMenu = ({ key }) => {
    history.push(`/category${key}`)
    setIsOpen(false)
  }

  return (
    <Header className={classnames('nav-header', { toggle: isOpen })}>
      <div className="logo-group">
        <div className={classnames('hamburger', { toggle: isOpen })} onClick={handleHamburger}>
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
        </div>
        <Link to="/">
          <img className="logo" src="/assets/images/vroom_logo.png" alt="vroom Logo" />
        </Link>
      </div>

      <ul className={classnames('nav-links', { open: isOpen })}>
        <li className={classnames('links')}>
          <a href={window.env.VROOM_HOMEPAGE}>Home</a>
        </li>
        {/* {map(navContent, (v) => {
          let pathLang = ''
          if (v.iconName !== 'PhoneOutlined' && v.title !== 'google') {
            pathLang = `?language=${i18n.language === 'cn' ? 'en' : i18n.language}`
          }
          return (
            <li
              key={get(v, 'id')}
              className={classnames('links', { active: '/' === get(v, 'link') })}>
              <a href={`${get(v, 'link')}${pathLang}`}>
                <Icon component={IconAnt[`${v.iconName}`]} />
                {get(v, 'title')}
              </a>
            </li>
          )
        })} */}
      </ul>
      {/* <ul className={classnames('nav-langs', { open: isOpen })}>
        <button className="login-button" onClick={() => handleChangLang('th')}>
          <IconTH active={i18n.language === 'th'} />
        </button>
        <button className="login-button" onClick={() => handleChangLang('en')}>
          <IconEN active={i18n.language === 'en' || i18n.language === 'cn'} />
        </button>
        <button className="login-button" onClick={() => handleChangLang('cn')}>
          <IconCN active={i18n.language === 'cn'} />
        </button>
      </ul> */}

      <MenuSidebar
        className={classnames('nav-menus', { open: isOpen })}
        defaultSelectedKeys={`${slugArray.reduce((a, c) => `${a}/${c.slug}`, '')}`}
        onSelect={onSelectMenu}
        dataMenu={dataMenu}
      />
    </Header>
  )
}

export default Navigator
